<script setup>
defineProps({
  isFocused: { type: Boolean, default: false },
});

// // TvP08FunctionButton setup functions

// // TvP08FunctionButton handler functions

// // TvP08FunctionButton watchers
</script>

<template>
  <button
    type="button"
    class="tvp-08-function-button"
    :class="{ 'tvp-08-function-button--focused': isFocused }"
  >
    <!-- // Placeholder icon (matches the TVP8 library's ic_player_play_from_start reference —
         // the user has already flagged this as a stand-in to be swapped out later). -->
    <span class="tvp-08-function-button__icon">↺</span>
  </button>
</template>

<style scoped lang="scss">
@use './tvp08functionbutton.scss';
</style>
